module.exports = __webpack_public_path__ + "static/media/ProjectLayout.2e2decfd.webp";